<p-toast></p-toast>
<div class="grid grid-cols-12 gap-8 p-4">
	<div class="col-span-full lg:col-span-4">
		<div class="card">
			<div class="font-semibold text-xl mb-4">{{ translateServ.dictionary?.['INDEX_UPLOADER_TIT'] || 'Upload Index Files' }}</div>
			<p-message severity="error" [style]="{ 'margin-bottom': '1rem' }" class="blinking-warning">
				<span>
					<b>{{ translateServ.dictionary?.['ATTENTION'] }}</b> {{ translateServ.dictionary?.['ATTENTION_UPL'] }}:<br><b>{{viewScopeService.getCurrentCustomerName() }}</b>.
				</span>
			</p-message>
			<p-fileupload #fileUpload name="file" [multiple]="true" mode="advanced" [auto]="false"
				[showUploadButton]="true" [showCancelButton]="true" [url]="uploadApiUrl"
				(onSelect)="onFilesSelected($event)" (onBeforeUpload)="onBeforeUpload()" (onUpload)="onUpload($event)"
				(onError)="onError($event)" (onRemove)="onFileRemoved($event)"
				[chooseLabel]="translateServ.dictionary?.['UPLOADER_CHOOSE'] || 'Choose'"
				[uploadLabel]="translateServ.dictionary?.['UPLOADER_UPLOAD'] || 'Upload'"
				[cancelLabel]="translateServ.dictionary?.['UPLOADER_CANCEL'] || 'Cancel'" accept=".xlsx"
				maxFileSize="50000000" [disabled]="uploadedFileInfo.length >= 3">
				<ng-template pTemplate="empty">
					<div class="flex align-items-center justify-content-center p-4">
						<i class="pi pi-file-arrow-up text-4xl mr-2"></i>
						<span class="text-lg">{{ translateServ.dictionary?.['UPLOADER_INSTRUCTION'] || 'Drag and drop up
							to 3 .xlsx files here or click to select' }}</span>
					</div>
				</ng-template>
			</p-fileupload>
		</div>
	</div>

	<div class="col-span-full lg:col-span-8">
			   <div class="card">
				   <p-tabView [(activeIndex)]="activeTabIndex">
				<p-tabPanel>
					<ng-template pTemplate="header">
						<i *ngIf="infoTabState === 'default'" class="pi pi-circle text-gray-400 mr-2"></i>
						<i *ngIf="infoTabState === 'working'" class="pi pi-spin pi-spinner text-primary-500 mr-2"></i>
						<i *ngIf="infoTabState === 'blocked'" class="pi pi-minus-circle text-red-500 mr-2"></i>
						<i *ngIf="infoTabState === 'done'" class="pi pi-check-circle text-green-500 mr-2"></i>
						{{ translateServ.dictionary['INDEX_ACT_TAB_INFO'] }}
					</ng-template>
					<div class="font-semibold text-xl mb-4">{{
						translateServ.dictionary?.['UPLOADED_FILES_INFO_SUBTITLE'] || 'Uploaded Index Results' }}</div>
					<ng-container *ngIf="allFilesPending">
						<div class="flex flex-col items-center justify-center py-6">
							<i class="pi pi-spin pi-spinner text-4xl mb-2"></i>
							<div class="text-lg text-gray-600">{{ translateServ.dictionary['INDEX_SECT_WORKING_MSG'] }}</div>
						</div>
					</ng-container>
					<p-table [value]="uploadedFileInfo" [paginator]="true" [rows]="10"
						[totalRecords]="uploadedFileInfo.length || 0" [rowsPerPageOptions]="[5, 10, 20, 50]"
						[showCurrentPageReport]="true"
						currentPageReportTemplate="{{translateServ.dictionary['TAB_FOOTER_SHOWING']}} {first}
                                                            {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} 
                                                            {{ translateServ.dictionary['TAB_FOOTER_ENTRIES']}}"
						[tableStyle]="{'min-width': '30rem'}">
						<ng-template pTemplate="header">
							<tr>
								<th>{{ translateServ.dictionary?.['FILE_NAME'] || 'File Name' }}</th>
								<th>{{ translateServ.dictionary?.['FILE_SIZE'] || 'File Size' }}</th>
								<th>{{ translateServ.dictionary?.['FILE_TYPE'] || 'File Type' }}</th>
								<th>{{ translateServ.dictionary?.['FILE_STATUS'] || 'Status' }}</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>
							<tr>
								<td>{{ item.file.name }}</td>
								<td>{{ item.file.size | number }} bytes</td>
								<td>
									<p-tag [value]="item.file.type" [severity]="'info'"></p-tag>
								</td>
								<td>
									<p-tag [value]="item.disp_status"
										[severity]="getStatusSeverity(item.status)"></p-tag>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="4">{{ translateServ.dictionary?.['UPLOADED_STAT_EMPTY'] || 'No files uploaded yet.' }}</td>
							</tr>
						</ng-template>
					</p-table>
				</p-tabPanel>
				<p-tabPanel [disabled]="!allSectionsLoaded">
					<ng-template pTemplate="header">
						<i *ngIf="sectionsTabState === 'working'"
							class="pi pi-spin pi-spinner text-primary-500 mr-2"></i>
						<i *ngIf="sectionsTabState === 'blocked'" class="pi pi-minus-circle text-red-500 mr-2"></i>
						<i *ngIf="sectionsTabState === 'done'" class="pi pi-check-circle text-green-500 mr-2"></i>
						{{ translateServ.dictionary['INDEX_ACT_TAB_SECT'] }}
					</ng-template>
					<div *ngIf="calculatedSections.length > 0">
						<ng-container *ngIf="!isSavingAssignments; else workingBlock">
							<p-table [value]="calculatedSections" [tableStyle]="{'min-width': '30rem'}">
								<ng-template pTemplate="header">
									<tr>
										<th>{{ translateServ.dictionary['INDEX_TABL_SEC_CODE'] }}</th>
										<th>{{ translateServ.dictionary['INDEX_TABL_SEC_NAME'] }}</th>
										<th>{{ translateServ.dictionary['INDEX_TABL_SEC_ASSIG'] }}</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
									<tr>
										<td>{{ row.code }}</td>
										<td>{{ row.label }}</td>
										<td style="min-width: 200px;">
											<p-autoComplete [(ngModel)]="row.selectedSection"
												[suggestions]="filteredSectionOptions[rowIndex] || []"
												(completeMethod)="filterSectionOptions($event, rowIndex)"
												[optionLabel]="'label'" [dropdown]="true" [appendTo]="'body'"
												[forceSelection]="true" placeholder="Select section...">
												<ng-template let-item pTemplate="item">
													<span>{{ item.label }} <span *ngIf="item.code">({{ item.code }})</span></span>
												</ng-template>
											</p-autoComplete>
										</td>
									</tr>
								</ng-template>
							</p-table>
							<div class="flex justify-end mt-4">
								<button pButton type="button" label="Send" class="p-button-success" [disabled]="!allSectionsAssigned" (click)="onSendAssignments()">{{ translateServ.dictionary['INDEX_BTN_SAV_ASSIG'] }}</button>
							</div>
						</ng-container>
						<ng-template #workingBlock>
							<div class="flex flex-col items-center justify-center py-6">
								<i class="pi pi-spin pi-spinner text-4xl mb-2"></i>
								<div class="text-lg text-gray-600">{{ translateServ.dictionary['INDEX_SECT_WORKING_MSG'] }}</div>
							</div>
						</ng-template>
					</div>
					<div *ngIf="calculatedSections.length === 0" class="text-gray-500">{{ translateServ.dictionary['NO_DISP_MSG'] }}</div>
				</p-tabPanel>
				   <p-tabPanel [disabled]="!apiResult && !errorMessage">
					   <ng-template pTemplate="header">
						   <i *ngIf="finishTabState === 'working'" class="pi pi-spin pi-spinner text-primary-500 mr-2"></i>
						   <i *ngIf="finishTabState === 'blocked'" class="pi pi-minus-circle text-red-500 mr-2"></i>
						   <i *ngIf="finishTabState === 'done'" class="pi pi-check-circle text-green-500 mr-2"></i>
						   {{ translateServ.dictionary['INDEX_ACT_TAB_FINISH'] }}
					   </ng-template>
											<button pButton type="button" icon="pi pi-download" class="p-button-info mb-4" (click)="downloadExcelOfResults()">
												<span class="pi pi-download mr-2"></span>
												<span>{{ translateServ.dictionary['DOWNLOAD_FILE'] }}</span>
											</button>
					<div class="flex flex-col items-center justify-center py-8">
						<ng-container *ngIf="errorMessage; else resultTabsBlock">
							<i class="pi pi-times-circle text-4xl text-red-500 mb-4"></i>
							<div class="text-xl font-semibold text-red-600 mb-2">{{ translateServ.dictionary['INDEX_ERR_MSG'] }}</div>
							<div class="mb-4">{{ errorMessage }}</div>
							<button pButton type="button" label="Try Again" class="p-button-danger"
								(click)="fileUpload.clear(); errorMessage = null; uploadRefNum = null; calculatedSections = []; allSectionsLoaded = false;">Try
								to re-upload</button>
						</ng-container>
						<ng-template #resultTabsBlock>
							<i class="pi pi-check-circle text-4xl text-green-500 mb-4"></i>
							<div class="text-xl font-semibold text-green-700 mb-2">{{ translateServ.dictionary['INDX_MSG_FINNISH'] }}</div>
							<div class="mb-4"> {{ translateServ.dictionary['INDX_MSG_AFTERMATH'] }} </div>
							<div style="width: 100%; display: flex; justify-content: center;">
								<p-tabView *ngIf="apiResult" [scrollable]="true" [style]="{'max-width':'600px', 'width':'100%', 'direction': 'ltr'}">
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_SUP_FAILED']}}">
									<p-message severity="error" text="{{ translateServ.dictionary['INDEX_UPL_M_SUP_FAILED']}}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Table" [tableStyle]="{'min-width': '520px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:100px;">{{ translateServ.dictionary['ItemCodeMiun'] }}</th>
													<th style="width:110px;">{{ translateServ.dictionary['ItemAccountKey'] }}</th>
													<th style="width:130px;">{{ translateServ.dictionary['ItemAccountName'] }}</th>
													<th style="width:110px;">{{ translateServ.dictionary['ItemBusiness_ID'] }}</th>
													<th style="width:60px;">{{ translateServ.dictionary['IsExist'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.ItemCodeMiun}}</td>
													<td>{{row.ItemAccountKey}}</td>
													<td>{{row.ItemAccountName}}</td>
													<td>{{row.ItemBusiness_ID}}</td>
													<td>{{row.IsExist}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="5">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_SUP_ATTENT']}}">
									<p-message severity="warn" text="{{ translateServ.dictionary['INDEX_UPL_M_SUP_ATTENT']}}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Table1" [tableStyle]="{'min-width': '520px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:100px;">{{ translateServ.dictionary['ItemCodeMiun'] }}</th>
													<th style="width:110px;">{{ translateServ.dictionary['ItemAccountKey'] }}</th>
													<th style="width:130px;">{{ translateServ.dictionary['ItemAccountName'] }}</th>
													<th style="width:110px;">{{ translateServ.dictionary['ItemBusiness_ID'] }}</th>
													<th style="width:60px;">{{ translateServ.dictionary['IsExist'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.ItemCodeMiun}}</td>
													<td>{{row.ItemAccountKey}}</td>
													<td>{{row.ItemAccountName}}</td>
													<td>{{row.ItemBusiness_ID}}</td>
													<td>{{row.IsExist}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="5">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_BUSID_DUP']}}">
									<p-message severity="warn" text="{{ translateServ.dictionary['INDEX_UPL_M_BUSID_DUP']}}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Table2" [tableStyle]="{'min-width': '400px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:200px;">{{ translateServ.dictionary['Business_ID'] }}</th>
													<th style="width:100px;">{{ translateServ.dictionary['COUNT'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.Business_ID}}</td>
													<td>{{row.count}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="2">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_BUSNM_DUP']}}">
									<p-message severity="warn" text="{{ translateServ.dictionary['INDEX_UPL_M_BUSNM_DUP']}}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Table3" [tableStyle]="{'min-width': '400px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:200px;">{{ translateServ.dictionary['BusinessName'] }}</th>
													<th style="width:100px;">{{ translateServ.dictionary['COUNT'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.CustomerName}}</td>
													<td>{{row.count}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="2">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_BUSID_EMPT'] }}">
									<p-message severity="error" text="{{ translateServ.dictionary['INDEX_UPL_M_BUSID_EMPT'] }}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Table4" [tableStyle]="{'min-width': '400px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:120px;">{{ translateServ.dictionary['ItemAccountKey'] }}</th>
													<th style="width:120px;">{{ translateServ.dictionary['ItemExpenseCode'] }}</th>
													<th style="width:200px;">{{ translateServ.dictionary['BusinessName'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.customer_supplier_num}}</td>
													<td>{{row.CustomerSupplierExpenseCode}}</td>
													<td>{{row.SupplierName}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="3">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<!-- Table 6 removed as requested -->
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_INFO_PAY'] }}">
									<p-message severity="info" text="{{ translateServ.dictionary['INDEX_UPL_M_INFO_PAY'] }}"></p-message>
									<div style="overflow-x: auto; max-width: 100%;">
										<p-table [value]="apiResult.DataSetResult.Payments_0" [tableStyle]="{'min-width': '900px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:100px;">{{ translateServ.dictionary['ItemAccountKey'] }}</th>
													<th style="width:180px;">{{ translateServ.dictionary['ItemAccountKey'] }}</th>
													<th style="width:110px;">{{ translateServ.dictionary['PaymentType'] }}</th>
													<th style="width:120px;">{{ translateServ.dictionary['payment_credit_card_number'] }}</th>
													<th style="width:140px;">{{ translateServ.dictionary['CreditCardName'] }}</th>
													<th style="width:90px;">{{ translateServ.dictionary['payment_bank_number'] }}</th>
													<th style="width:90px;">{{ translateServ.dictionary['payment_bank_branch'] }}</th>
													<th style="width:160px;">{{ translateServ.dictionary['payment_bank_name'] }}</th>
													<th style="width:120px;">{{ translateServ.dictionary['payment_bank_account_number'] }}</th>
													<th style="width:90px;">{{ translateServ.dictionary['FF_PAY_BANK_CODE'] }}</th>
													<th style="width:160px;">{{ translateServ.dictionary['FF_PAY_BANK_OF_HE'] }}</th>
													<th style="width:160px;">{{ translateServ.dictionary['FF_PAY_BANK_OF_EN'] }}</th>
													<th style="width:60px;">{{ translateServ.dictionary['IS_BANK_UPD'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.ItemAccountKey}}</td>
													<td>{{row.ItemAccountName}}</td>
													<td>{{row.PaymentType}}</td>
													<td>{{row.CreditCardNum}}</td>
													<td>{{row.CreditCardName}}</td>
													<td>{{row.BankNum}}</td>
													<td>{{row.BankBranch}}</td>
													<td>{{row.BankName}}</td>
													<td>{{row.BankAccountNum}}</td>
													<td>{{row.BankCode}}</td>
													<td>{{row.BankOfficialNameEn}}</td>
													<td>{{row.BankOfficialNameHe}}</td>
													<td>{{row.IsBankUpdated}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="13">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								<p-tabPanel header="{{ translateServ.dictionary['INDEX_UPL_T_INFO_EXP'] }}">
									<p-message severity="info" text="{{ translateServ.dictionary['INDEX_UPL_M_INFO_EXP'] }}"></p-message>
									<div style="overflow-x: auto;">
										<p-table [value]="apiResult.DataSetResult.CustomerMoveCode6111_0" [tableStyle]="{'min-width': '320px'}">
											<ng-template pTemplate="header">
												<tr>
													<th style="width:140px;">{{ translateServ.dictionary['STEP_TAB_TIT_EXP_CODE'] }}</th>
													<th style="width:180px;">{{ translateServ.dictionary['MAINT_IN_TIT_DESC'] }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-row>
												<tr>
													<td>{{row.ExpenseCode}}</td>
													<td>{{row.Descr}}</td>
												</tr>
											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr><td colspan="2">{{ translateServ.dictionary['NO_DISP_MSG'] }}...</td></tr>
											</ng-template>
										</p-table>
									</div>
								</p-tabPanel>
								</p-tabView>
							</div>
						</ng-template>
					</div>
				</p-tabPanel>
			</p-tabView>
		</div>
	</div>
</div>